import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { RequireScope } from "src/components/RequireScope";

import IntegrationsMainContent from "../components/IntegrationsMainContent";
import { useSettingsMobileHeader } from "../hooks/useSettingsMobileHeader";
import { IntegrationsRouteQuery } from "./__generated__/IntegrationsRouteQuery.graphql";

const integrationsRouteQuery = graphql`
  query IntegrationsRouteQuery {
    me {
      ...appMe
      organization {
        ...IntegrationsMainContent_organization
      }
    }
  }
`;

export default function IntegrationsRoute() {
  return (
    <RequireScope scope="read:integrations">
      <IntegrationsRouteContent />
    </RequireScope>
  );
}

function IntegrationsRouteContent() {
  useSettingsMobileHeader("Integrations");
  const data = useLazyLoadQuery<IntegrationsRouteQuery>(
    integrationsRouteQuery,
    {},
    { fetchPolicy: "store-and-network" }
  );

  const organization = data.me?.organization;

  if (!organization) {
    return <div>Organization not found</div>;
  }

  return <IntegrationsMainContent organization={organization} />;
}
